// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import {
  Container,
  Row,
  Col,
  Card,
  CardBlock,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  Alert,
} from 'reactstrap';

import { login, logout } from 'actions/auth';

type Props = {
  // recompose
  username: string,
  onUsernameChange: (username: string) => mixed,
  password: string,
  onPasswordChange: (password: string) => mixed,

  // redux
  isAuthenticated: boolean,
  isManager: boolean,
  isGroupleader: boolean,
  authFailed: boolean,
  onLogin: typeof login,
  onLogout: typeof logout,
};

class Login extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.props.isAuthenticated) {
      this.props.onLogout();
    }
  }

  _onLogin = async () => {
    const { username, password, onLogin } = this.props;
    await onLogin({ username, password });
    if (this.props.isAuthenticated) {
      if (this.props.isManager) {
        this.context.router.history.push('/reports');
      } else if (this.props.isGroupleader) {
        this.context.router.history.push('/topics');
      } else {
        this.context.router.history.push('/');
      }
    }
  };

  render() {
    const {
      authFailed,
      username,
      onUsernameChange,
      password,
      onPasswordChange,
    } = this.props;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="p-4">
                <CardBlock className="card-body">
                  <h1 style={{ marginBottom: 24 }}>Login</h1>
                  <InputGroup className="mb-3">
                    <InputGroupAddon>
                      <i className="icon-user" />
                    </InputGroupAddon>
                    <Input
                      type="text"
                      placeholder="Username"
                      value={username}
                      onChange={value => onUsernameChange(value.target.value)}
                    />
                  </InputGroup>
                  <InputGroup className="mb-4">
                    <InputGroupAddon>
                      <i className="icon-lock" />
                    </InputGroupAddon>
                    <Input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={value => onPasswordChange(value.target.value)}
                    />
                  </InputGroup>
                  {authFailed && (
                    <Alert color="danger">
                      Benutzername und/oder Password falsch.
                    </Alert>
                  )}
                  <Row>
                    <Col xs="6">
                      <Button
                        color="primary"
                        className="px-4"
                        onClick={this._onLogin}
                      >
                        Login
                      </Button>
                    </Col>
                  </Row>
                </CardBlock>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ auth: { isAuthenticated, errorCode, user } }) => ({
  isAuthenticated,
  isGroupleader: !!user && user.groupLeader,
  isManager: !!user && user.manager,
  authFailed: errorCode === 'VAL100',
});

const mapDispatchToProps = dispatch => ({
  onLogin: (...args) => dispatch(login(...args)),
  onLogout: (...args) => dispatch(logout(...args)),
});

const LoginContainer = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('username', 'onUsernameChange', ''),
  withState('password', 'onPasswordChange', '')
)(Login);

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js